import { IResourceComponentsProps, useShow } from "@pankod/refine-core";
import { Show, Typography } from "@pankod/refine-antd";

import { ISellers } from "interfaces";

const { Title, Text } = Typography;

export const SellersShow: React.FC<IResourceComponentsProps> = () => {
  const { queryResult } = useShow<ISellers>();
  const { data, isLoading } = queryResult;
  const record = data?.data;

  return (
    <Show isLoading={isLoading}>
      <Title level={5}>Id Vendedor</Title>
      <Text>{record?.SellerId}</Text>

      <Title level={5}>Nome</Title>
      <Text>{record?.SellerName}</Text>

      <Title level={5}>Id Origem</Title>
      <Text>{record?.OriginId}</Text>

      <Title level={5}>Id Filial</Title>
      <Text>{record?.BranchOfficeId}</Text>

      <Title level={5}>Id Área Venda</Title>
      <Text>{record?.SalesAreaId}</Text>
    </Show>
  );
};
